import * as React from 'react';
import "../../../node_modules/@jcharlesworthuk/your-mum-frontend/components/articles/Markdown.scss";
import { Mdx } from '@GraphQLModels';
import { childClassClosure, baseClassAnd, ClassableProps } from "@jcharlesworthuk/your-mum-core/dist/functions";
import { MDXRenderer } from "gatsby-plugin-mdx";
import AcordeContactForm from "../forms/AcordeContactForm";
import ArticleCta from './ArticleCta';
import ArticleImage from "@jcharlesworthuk/your-mum-frontend/components/articles/ArticleImage";
import StepByStepSection from '../marketing/StepByStepSection';
import SellingFeatureRow from '../marketing/SellingFeatureRow';
import Step from '../marketing/Step';
import MdxArticleList from '../content/MdxArticleList';
import AcordeAnimatedSteps from '../marketing/AcordeAnimatedSteps';
import SubscriptionSelector from '../selling/SubscriptionSelector';
import { MDXProvider } from "@mdx-js/react"


const baseClass = 'markdown';

type Props  = ClassableProps & {
  mdx: Mdx;
}


const components = {
  ArticleCta,
  ArticleImage,
  SellingFeatureRow,
  AcordeContactForm,
  StepByStepSection,
  Step,
  MdxArticleList,
  AcordeAnimatedSteps,
  SubscriptionSelector
}


const MdxBlock: React.FunctionComponent<Props> = (props: Props) => {

  return <article className={baseClassAnd(baseClass, props)}>
    <MDXProvider components={components}>
      <MDXRenderer>{props.mdx.body}</MDXRenderer>
    </MDXProvider>
  </article >
}
export default MdxBlock;
